import CollectionList from "@/js/Shared/Collections/CollectionList";

export {KidsDataItem as default};

/**
 * @description Entity Kids Data
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 *
 * @private
 */
class KidsDataItem {

  /**
   * Identify if account is kids
   *
   * @type {Boolean}
   * @default false
   */
  is_kid_account = false;

  /**
   * Identify if parent is authenticated
   *
   * @type {Boolean}
   * @default false
   */
  parent_authenticated = false;

  /**
   * Manager authentication method
   * of education
   * 
   * @type {String}
   */
  auth_parent_method;

  /**
   * Identifies which action is applied
   * in unidentified emails
   *
   * @type {String|null}
   */
  authorized_action_emails = null;

  /**
   * Identifies whether the whitelist filter is
   * active or not on the Kids account
   *
   * @type {Number|null}
   */
  whitelist_active = null;

  /**
   * Account whitelist email collection
   * kids
   *
   * @type {CollectionList}
   */
  whitelist = new CollectionList("email");
}